import { render, staticRenderFns } from "./FormSurvey.vue?vue&type=template&id=c840cd78&scoped=true&"
import script from "./FormSurvey.vue?vue&type=script&lang=js&"
export * from "./FormSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c840cd78",
  null
  
)

/* custom blocks */
import block0 from "./FormSurvey.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c840cd78')) {
      api.createRecord('c840cd78', component.options)
    } else {
      api.reload('c840cd78', component.options)
    }
    module.hot.accept("./FormSurvey.vue?vue&type=template&id=c840cd78&scoped=true&", function () {
      api.rerender('c840cd78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/comparison/FormSurvey.vue"
export default component.exports